import { render, staticRenderFns } from "./doPaper_new.vue?vue&type=template&id=5ad1ae66&scoped=true"
import script from "./doPaper_new.vue?vue&type=script&lang=js"
export * from "./doPaper_new.vue?vue&type=script&lang=js"
import style0 from "./doPaper_new.vue?vue&type=style&index=0&id=5ad1ae66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad1ae66",
  null
  
)

export default component.exports